(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baggu-home-collections"]) return;
  try {
    
  (() => {
    const SELECTOR = '[data-baggu-inline-slider-section="collections"]';

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    function initSlider(section) {
      if (!section || section.dataset.bagguSliderBound === 'true') {
        return;
      }

      section.dataset.bagguSliderBound = 'true';

      const viewport = section.querySelector('[data-baggu-slider-viewport]');
      const track = section.querySelector('[data-baggu-slider-track]');
      const cards = Array.from(section.querySelectorAll('.baggu-home-collections-v2__card'));
      const prevButton = section.querySelector('[data-baggu-slider-prev]');
      const nextButton = section.querySelector('[data-baggu-slider-next]');

      if (!viewport || !track || cards.length === 0) {
        return;
      }

      let index = 0;
      let dragStartX = 0;
      let dragDeltaX = 0;
      let dragging = false;

      const total = cards.length;

      function step() {
        if (!cards[0]) {
          return 0;
        }

        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0');
        return cards[0].getBoundingClientRect().width + gap;
      }

      function visibleCards() {
        const cardStep = step();
        const viewportWidth = viewport.getBoundingClientRect().width;

        if (!cardStep || !viewportWidth) {
          return 1;
        }

        return Math.max(1, Math.floor((viewportWidth + 1) / cardStep));
      }

      function render(delta = 0, immediate = false) {
        const maxIndex = Math.max(total - visibleCards(), 0);

        index = clamp(index, 0, maxIndex);
        track.style.transition = immediate ? 'none' : 'transform 220ms ease';
        track.style.transform = `translate3d(${(-1 * step() * index) + delta}px, 0, 0)`;
      }

      function commit(direction) {
        index += direction;
        render();
      }

      prevButton?.addEventListener('click', () => commit(-1));
      nextButton?.addEventListener('click', () => commit(1));

      viewport.addEventListener('touchstart', (event) => {
        dragStartX = event.touches[0].clientX;
        dragDeltaX = 0;
        dragging = true;
        render(0, true);
      }, { passive: true });

      viewport.addEventListener('touchmove', (event) => {
        if (!dragging) {
          return;
        }

        dragDeltaX = event.touches[0].clientX - dragStartX;
        render(dragDeltaX, true);

        if (event.cancelable) {
          event.preventDefault();
        }
      }, { passive: false });

      function finishTouch() {
        if (!dragging) {
          return;
        }

        const threshold = Math.max(30, step() * 0.16);

        if (dragDeltaX <= (threshold * -1)) {
          index += 1;
        } else if (dragDeltaX >= threshold) {
          index -= 1;
        }

        dragging = false;
        dragDeltaX = 0;
        render();
      }

      viewport.addEventListener('touchend', finishTouch, { passive: true });
      viewport.addEventListener('touchcancel', finishTouch, { passive: true });
      window.addEventListener('resize', () => render(0, true));

      render(0, true);
    }

    function boot(context = document) {
      context.querySelectorAll(SELECTOR).forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baggu-home-reusables"]) return;
  try {
    
  (() => {
    const SELECTOR = '[data-baggu-mobile-slider-section="reusables"]';

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const pad = (value) => String(value).padStart(2, '0');

    function initSlider(section) {
      if (!section || section.dataset.bagguSliderBound === 'true') {
        return;
      }

      section.dataset.bagguSliderBound = 'true';

      const viewport = section.querySelector('[data-baggu-slider-viewport]');
      const track = section.querySelector('[data-baggu-slider-track]');
      const cards = Array.from(section.querySelectorAll('.baggu-home-reusables-v2__card'));
      const prevButton = section.querySelector('[data-baggu-slider-prev]');
      const nextButton = section.querySelector('[data-baggu-slider-next]');
      const currentNode = section.querySelector('[data-baggu-slider-current]');
      const totalNode = section.querySelector('[data-baggu-slider-total]');
      const fillNode = section.querySelector('[data-baggu-slider-fill]');

      if (!viewport || !track || cards.length === 0) {
        return;
      }

      let index = 0;
      let dragStartX = 0;
      let dragDeltaX = 0;
      let dragging = false;

      const total = cards.length;

      function isMobile() {
        return viewport.getBoundingClientRect().width <= 520;
      }

      function step() {
        if (!cards[0]) {
          return 0;
        }

        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0');
        return cards[0].getBoundingClientRect().width + gap;
      }

      function render(delta = 0, immediate = false) {
        const activeMobile = isMobile();
        const maxIndex = Math.max(total - 2, 0);
        const totalPages = activeMobile ? (maxIndex + 1) : total;

        index = clamp(index, 0, activeMobile ? maxIndex : 0);

        if (!activeMobile) {
          track.style.transition = '';
          track.style.transform = '';
        } else {
          track.style.transition = immediate ? 'none' : 'transform 220ms ease';
          track.style.transform = `translate3d(${(-1 * step() * index) + delta}px, 0, 0)`;
        }

        if (currentNode) {
          currentNode.textContent = pad(index + 1);
        }

        if (totalNode) {
          totalNode.textContent = pad(totalPages);
        }

        if (fillNode) {
          const denominator = activeMobile ? Math.max(total - 1, 1) : Math.max(total - 1, 1);
          const ratio = total > 1 ? index / denominator : 1;
          fillNode.style.width = `${Math.max(18, ratio * 100)}%`;
        }

        if (prevButton) {
          prevButton.disabled = index <= 0;
        }

        if (nextButton) {
          nextButton.disabled = index >= (activeMobile ? maxIndex : 0);
        }
      }

      function commit(direction) {
        if (!isMobile()) {
          index = 0;
          render(0, true);
          return;
        }

        index += direction;
        render();
      }

      prevButton?.addEventListener('click', () => commit(-1));
      nextButton?.addEventListener('click', () => commit(1));

      viewport.addEventListener('touchstart', (event) => {
        if (!isMobile()) {
          return;
        }

        dragStartX = event.touches[0].clientX;
        dragDeltaX = 0;
        dragging = true;
        render(0, true);
      }, { passive: true });

      viewport.addEventListener('touchmove', (event) => {
        if (!dragging || !isMobile()) {
          return;
        }

        dragDeltaX = event.touches[0].clientX - dragStartX;
        render(dragDeltaX, true);

        if (event.cancelable) {
          event.preventDefault();
        }
      }, { passive: false });

      function finishTouch() {
        if (!dragging) {
          return;
        }

        const threshold = Math.max(30, step() * 0.16);

        if (dragDeltaX <= (threshold * -1)) {
          index += 1;
        } else if (dragDeltaX >= threshold) {
          index -= 1;
        }

        dragging = false;
        dragDeltaX = 0;
        render();
      }

      viewport.addEventListener('touchend', finishTouch, { passive: true });
      viewport.addEventListener('touchcancel', finishTouch, { passive: true });
      window.addEventListener('resize', () => render(0, true));

      render(0, true);
    }

    function boot(context = document) {
      context.querySelectorAll(SELECTOR).forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
